/* jQuery COMPONENTS */

COMPONENTS.LinkSelect = (function ($) {
  function LinkSelect () {
    this.$linkSelects = $('[data-ecs-components-control="link-select"]')
  }

  LinkSelect.prototype.init = function () {
    this.$linkSelects.each(function () {
      const $linkSelect = $(this)

      $linkSelect.niceSelect()

      $linkSelect.change(function () {
        if ($(this).val() !== '-') {
          window.open($(this).val(), '_blank')
          $(this).val('-').niceSelect('update')
        }
      })
    })
  }

  return LinkSelect
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.linkSelect = new COMPONENTS.LinkSelect()
  COMPONENTS.linkSelect.init()
})
